import { Box } from "@mui/material";
import type { DateTime } from "luxon";
import type { ComponentProps, FC } from "react";
import { EditTimePopover } from "../../../EditTimePopover";

type EditTimePopoverProps = ComponentProps<typeof EditTimePopover>;

type Props = {
	startTime: DateTime;
	endTime: DateTime;
	/** Every valid change, streamed up as it is made — the sheet's footer commits it. */
	onTimeChange: EditTimePopoverProps["onTimeChange"];
	/** With `jobId`, decides which shift lengths the editor offers — the same inputs its desktop callers pass. */
	role: EditTimePopoverProps["role"];
	jobId: string | undefined;
	dataTestId: string;
	maximumDurationHours?: number;
};

/**
 * The desktop time editor (`EditTimePopover`) as a gaps sheet step embeds it — inline, in its touch appearance — so
 * every step that changes hours (a person's shift, a posted shift) draws the same editor configured the same way.
 */
export const GapsSheetHoursPicker: FC<Props> = ({ startTime, endTime, onTimeChange, role, jobId, dataTestId, maximumDurationHours }) => (
	<Box data-testid={dataTestId}>
		<EditTimePopover
			startTime={startTime}
			endTime={endTime}
			onTimeChange={onTimeChange}
			// The sheet's footer owns Save and Back, so the picker's own Close/Apply are hidden (`hideActions`).
			onClose={() => undefined}
			anchorEl={null}
			menuWrapper={false}
			hideActions
			fullsize
			// Chips for a finger, the shift's own window marked — the desktop editor otherwise, unchanged.
			appearance="touch"
			// Portalled, so the time lists float above the sheet instead of being clipped by its scroller.
			disableAutoCompetePortal={false}
			isActual={false}
			role={role}
			jobId={jobId}
			maximumDurationHours={maximumDurationHours}
		/>
	</Box>
);
